@if (templateId) {
  <div class="file-downloader-container">
    <div class="file-name-header">
      <span>{{ 'FILE_DOWNLOADER.FILE_NAME' | translate }}</span>
      <span class="fw-semibold">{{ displayFileName }}</span>
    </div>
    <button class="btn file-download-button" [disabled]="isDownloadDisabled" (click)="downloadTemplate()">
      @if (!isDownloading) {
        <span class="text-icam-danger fw-semibold">{{
          'FILE_DOWNLOADER.DOWNLOAD' | translate
        }}</span>
      }
      @if (isDownloading) {
        <span class="text-muted fw-semibold">{{ 'FILE_DOWNLOADER.DOWNLOADING' | translate }}</span>
      }
    </button>
  </div>
}

@if (!templateId) {
  <div class="file-downloader-container">
    <div class="file-name-header">
      <span class="text-muted">{{ 'FILE_DOWNLOADER.NO_TEMPLATE_AVAILABLE' | translate }}</span>
    </div>
  </div>
}
